const VISORIA_BACKEND_URL =
  process.env.REACT_APP_VISORIA_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

function formatMoney(amount, currency) {
  if (amount == null || amount === "") {
    return "";
  }
  const value = Number(amount);
  if (Number.isNaN(value)) {
    return String(amount);
  }
  const wholeUnits = (currency === "RUB" || currency === "KZT") && Number.isInteger(value);
  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: currency || "USD",
      currencyDisplay: currency === "KZT" ? "narrowSymbol" : "symbol",
      minimumFractionDigits: wholeUnits ? 0 : undefined,
      maximumFractionDigits: wholeUnits ? 0 : 2,
    }).format(value);
  } catch {
    return `${value} ${currency || ""}`.trim();
  }
}

const MAX_DEALS = 60;

const STEAM_CDN_RE = /^https:\/\/shared\.(akamai|fastly)\.steamstatic\.com\/store_item_assets\//;

/** Обложки Steam — через наш сервер: у части покупателей CDN Steam из браузера не открывается. */
export function siteImage(url) {
  return url && STEAM_CDN_RE.test(url)
    ? `${VISORIA_BACKEND_URL}/api/visoria/steam/cover?u=${encodeURIComponent(url)}`
    : url;
}

/** Внешняя ссылка из чужих данных: только https, иначе null. */
export function httpsUrl(value) {
  try {
    const url = new URL(String(value || ""));
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}

/** Путь на нашем сайте: «/…», но не «//host». */
function sitePath(value) {
  return typeof value === "string" && /^\/(?![/\\])/.test(value) ? value : null;
}

function toAmount(value) {
  const amount = value == null || value === "" ? NaN : Number(value);
  return Number.isFinite(amount) ? amount : null;
}

function formatHistoryPeriod(days) {
  return days < 60 ? `${days} дн.` : `${Math.floor(days / 30)} мес.`;
}

/**
 * Метка по нашей истории цен, короткая — помещается в строку с ценой.
 * «Дешевле не было» честно только после года наблюдений.
 */
function mapPriceBadge(badge) {
  if (!badge?.type || !Number.isFinite(badge.days)) {
    return null;
  }
  const isNewLow = badge.type === "new_low";
  const label =
    badge.days >= 365
      ? isNewLow
        ? "дешевле не было"
        : "лучшая цена"
      : `лучшая за ${formatHistoryPeriod(badge.days)}`;
  return { type: badge.type, label };
}

function mapDeal(game) {
  const pricing = game?.pricing || {};
  return {
    id: game.id,
    nsuid: game.sku || null,
    name: game.name || "Без названия",
    cover: siteImage(game.cover) || "",
    coverSquare: Boolean(game.cover_square),
    coverWide: Boolean(game.cover_wide),
    coverFallback: siteImage(game.cover_fallback) || null,
    link: httpsUrl(game.psprices_url) || httpsUrl(game.url) || httpsUrl(game.store_url) || "#",
    storeUrl: httpsUrl(game.ps_store_url) || httpsUrl(game.store_url),
    discountPercent: pricing.discount_percent ?? null,
    amount: toAmount(pricing.current_price),
    originalAmount: toAmount(pricing.original_price),
    currency: pricing.currency || null,
    price: formatMoney(pricing.current_price, pricing.currency),
    originalPrice: formatMoney(pricing.original_price, pricing.currency),
    discountEndDate: pricing.discount_ends_at || null,
    platforms: game.platforms || [],
    priceBadge: mapPriceBadge(game.price_badge),
    seoPath: sitePath(game.seo_path),
  };
}

function buildCollectionUrl(region, platformQuery) {
  const safeRegion = encodeURIComponent(String(region || "us").toLowerCase());
  const safePlatform = encodeURIComponent(String(platformQuery || ""));
  return `https://psprices.com/region-${safeRegion}/collection/most-wanted-deals?platform=${safePlatform}`;
}

const pspricesDealsService = {
  getDeals: async (region, platforms) => {
    const params = new URLSearchParams({
      region: String(region || "").toLowerCase(),
      platforms: String(platforms || ""),
      collection: "most-wanted-deals",
    });
    const url = `${VISORIA_BACKEND_URL}/api/visoria/psprices/demo?${params.toString()}`;
    const response = await fetch(url, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) {
      throw new Error(`psprices proxy HTTP ${response.status}`);
    }
    const payload = await response.json();
    const results = Array.isArray(payload?.data)
      ? payload.data.slice(0, MAX_DEALS).map(mapDeal)
      : [];
    return {
      results,
      count: results.length,
      meta: payload?.meta || {},
    };
  },
  buildCollectionUrl,
};

export default pspricesDealsService;
